import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useApiPost from "../hooks/postData";
import toast from "react-hot-toast";
import Loader from '../../assets/Loader.gif';

function AddCoin({ open, handleClose, UserID, onSuccess }) {
  const { postData, loading } = useApiPost();
  const [amount, setAmount] = useState("");
  const [pin, setPin] = useState("");

  const handleClosePopup = () => {
    setAmount("");
    setPin("");
    handleClose();
  };

  const handleAddCoin = async () => {
    if (!amount || amount <= 0) {
      toast.error("Please enter a valid coin amount");
      return;
    }
    if (!/^\d{4}$/.test(pin)) {
      toast.error("Please enter your 4-digit PIN");
      return;
    }
    try {
      const response = await postData("/rooms/wallet/admin-add-coin", {
        user_id: UserID,
        coins: Number(amount),
        pin: pin,
      });
      if (response?.success) {
        toast.success(response.message || "Coins added successfully!");
        handleClosePopup();
        if (onSuccess) onSuccess();
      } else {
        toast.error(response?.message || "Failed to add coin");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <Dialog open={open} onClose={handleClosePopup} fullWidth className="custom-dialog">
      <DialogContent className="flex flex-col items-center gap-4 text-center dark:bg-primary">
        <h2 className="text-xl font-poppins text-[#000000] dark:text-darkText">
          Add Coin to User
        </h2>
        <input
          type="number"
          min="1"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="border border-gray-400 rounded-lg px-4 py-2 w-[220px] focus:outline-none focus:ring-1 focus:ring-gray-600 dark:bg-primary dark:text-darkText"
          placeholder="Enter coin amount"
        />
        <input
          type="password"
          maxLength={4}
          inputMode="numeric"
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
          className="border border-gray-400 rounded-lg px-4 py-2 w-[220px] text-center tracking-widest focus:outline-none focus:ring-1 focus:ring-gray-600 dark:bg-primary dark:text-darkText"
          placeholder="Enter 4-digit PIN"
        />
      </DialogContent>
      <DialogContent className="flex justify-center gap-4 pb-4 dark:bg-primary">
        <button
          className="w-[150px] py-2 border border-header text-[#3A3333] dark:text-darkText rounded-lg"
          onClick={handleClosePopup}
        >
          Cancel
        </button>
        <button
          onClick={handleAddCoin}
          style={{ backgroundColor: '#0D9947' }}
          className="w-[150px] py-2 text-white rounded-lg"
        >
          {loading ? (
            <div className="flex justify-center py-1">
              <img src={Loader} alt="loader" height={10} width={10} />
            </div>
          ) : (
            "Add Coin"
          )}
        </button>
      </DialogContent>
    </Dialog>
  );
}

export default AddCoin;